import React, { useEffect, useState } from 'react';
import { watchedRepos } from '../../data/watchedRepos';
import { getRepoStars, RepoStars } from '../../utils/github';
import { formatInt } from '../../utils/format';
import { DataBadge } from '../DataBadge';
import { SourceRef } from '../SourceRef';
import { PageSources } from '../PageSources';
export function WatchedRepos() {
  const [stars, setStars] = useState<Record<string, RepoStars>>({});
  useEffect(() => {
    let alive = true;
    watchedRepos.forEach(w => getRepoStars(w.fullName, w.snapshotStars).then(s => alive && setStars(prev => ({
      ...prev,
      [w.fullName]: s
    }))));
    return () => {
      alive = false;
    };
  }, []);
  const loaded = Object.values(stars);
  const allLive = loaded.length === watchedRepos.length && loaded.every(s => s.mode === 'live');
  const mode = loaded.length < watchedRepos.length ? 'loading' : allLive ? 'live' : 'snapshot';
  return <section aria-labelledby="watched-title" className="mt-16" data-id="element-214" data-mp="239ewv61qd59c">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-215" data-mp="2mixvpywxfnd8">
        <div data-id="element-216" data-mp="2igul1ci30mt0">
          <h2 id="watched-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-217" data-mp="2ih440g4pltp7">
            Agent repos we watch
          </h2>
          <p className="mt-1 max-w-2xl text-[14px] text-muted" data-id="element-218" data-mp="2dgga9mp3iyra">The frameworks and protocols most agents are built on, with current GitHub stars.</p>
        </div>
      </div>
      <PageSources data-id="element-219" data-mp="23k3ln38erb3e">
        <DataBadge mode={mode} source="GitHub · watched repo stars" asOf={mode === 'live' ? 'fetched just now' : undefined} data-id="element-220" data-mp="23klle9ua47g2" />
      </PageSources>
      <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-221" data-mp="1yr0lgc94l3e8">
        {watchedRepos.map(w => {
        const s = stars[w.fullName];
        return <li key={w.fullName} className="grid grid-cols-[minmax(0,1fr)_auto] items-baseline gap-x-6 gap-y-1 py-3.5 md:grid-cols-[12rem_minmax(0,1fr)_9rem_8rem]" data-id="element-222" data-mp="1ptqdp0vinwe2">
              <a href={`https://github.com/${w.fullName}`} target="_blank" rel="noopener noreferrer" className="text-[14.5px] text-ink hover:text-machine" data-id="element-223" data-mp="1ftpoiyayum1y">
                {w.label}
                <span className="ml-2 font-mono text-[11px] text-faint" data-id="element-224" data-mp="1b56u1mxthv4n">{w.fullName}</span>
              </a>
              <span className="col-span-2 row-start-2 text-[13px] text-muted md:col-span-1 md:row-start-auto" data-id="element-225" data-mp="x671w5b3iy3q">{w.why}</span>
              <span className="row-start-1 text-right font-mono text-lg tabular text-ink md:row-start-auto" data-id="element-226" data-mp="118bxh9l3u4t0">
                {s ? s.stars != null ? `★ ${formatInt(s.stars)}` : <span className="text-[13px] text-faint" data-id="element-227" data-mp="1tvoivgfj46kq">unavailable</span> : <span className="text-[13px] text-faint" data-id="element-228" data-mp="1tv6bporbw7y1">…</span>}
                {s?.stars != null && <SourceRef id="githubRepos" href={`https://api.github.com/repos/${w.fullName}`} grade="A" figure={w.label} data-id="element-229" data-mp="1g41knb210nzb" />}
              </span>
              <span className="hidden text-right font-mono text-[11.5px] text-faint md:block" data-id="element-230" data-mp="27vza4kkr3n6f">watching since {w.watchingSince}</span>
            </li>;
      })}
      </ul>

    </section>;
}